export { default as GDMContainer } from './GDMContainer';

export type { GDMContainerComponent, GDMContainerProps } from './GDMContainer.type';
